export const statusTransfer = (status) => {
  let color = status === 'available' ? 'success'
    : status === 'creating' ? 'warning'
      : status === 'reserved' ? 'error'
        : status === 'attaching' ? 'warning'
          : status === 'detaching' ? 'warning'
            : status === 'in-use' ? 'success'
              : status === 'maintenance' ? 'warning'
                : status === 'deleting' ? 'warning'
                  : status === 'awaiting-transfer' ? 'warning'
                    : status === 'error' ? 'error'
                      : status === 'error_deleting' ? 'error'
                        : status === 'backing-up' ? 'warning'
                          : status === 'restoring-backup' ? 'warning'
                            : status === 'error_backing-up' ? 'error'
                              : status === 'error_restoring' ? 'error'
                                : status === 'error_extending' ? 'error'
                                  : status === 'downloading' ? 'warning'
                                    : status === 'uploading' ? 'warning'
                                      : status === 'retyping' ? 'warning'
                                        : status === 'extending' ? 'warning'
                                          : 'warning'
  let statusZh = status === 'available' ? '可用'
    : status === 'creating' ? '创建中'
      : status === 'reserved' ? '搁置'
        : status === 'attaching' ? '连接实例中'
          : status === 'detaching' ? '从实例分离中'
            : status === 'in-use' ? '已挂载'
              : status === 'maintenance' ? '维护'
                : status === 'deleting' ? '删除中'
                  : status === 'awaiting-transfer' ? '等待转移'
                    : status === 'error' ? '错误'
                      : status === 'error_deleting' ? '删除时出错'
                        : status === 'backing-up' ? '备份中'
                          : status === 'restoring-backup' ? '备份还原中'
                            : status === 'error_backing-up' ? '备份时出错'
                              : status === 'error_restoring' ? '还原时出错'
                                : status === 'error_extending' ? '扩展时出错'
                                  : status === 'downloading' ? '下载镜像中'
                                    : status === 'uploading' ? '上传镜像中'
                                      : status === 'retyping' ? '修改卷类型中'
                                        : status === 'extending' ? '扩展中'
                                          : status
  return {status: statusZh, color: color}
}
